import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const SendMileageIndiComponent = React.lazy(() => import("../Components/RootComponents/SendMileageIndiComponent"));
const SendMileageIndiPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <SendMileageIndiComponent />
      </Suspense>
    </Fragment>
  );
};

export default SendMileageIndiPage;
